import localforage from 'localforage'

let localforageStoreSurveys = localforage.createInstance({
  name: 'qm-survey-webapp',
  storeName: 'surveys'
})

const initialState = {
  all: [],
  survey: {}
}

let state = initialState

// why do we actually try to merge data? - this has not been specified anywhere...
function mergeApiDataToState (stateSurvey, apiSurvey) {
  // never touch local surveys
  if (stateSurvey) {
    return stateSurvey
  }
  return apiSurvey
}

const getters = {
  getAllSurveys: (state) => {
    return state.all
  },
  getSurvey: (state) => {
    return state.survey
  },
  getNewSurveys: function (state) {
    return state.all.filter((survey) => {
      return (survey.opened !== true && !survey.closed && !survey.deleted)
    })
  },
  getOpenedSurveys: function (state) {
    return state.all.filter((survey) => {
      return (survey.opened === true && !survey.closed && !survey.deleted)
    })
  },
  getClosedSurveys: function (state) {
    return state.all.filter((survey) => {
      return (survey.opened === true && survey.closed === true && !survey.deleted)
    })
  },
  getDeletedSurveys: function (state) {
    return state.all.filter((survey) => {
      return (survey.opened === true && survey.closed === true && survey.deleted === true)
    })
  }
}

const actions = {
  loadActiveSurveys ({ commit, state }) {
    return new Promise((resolve, reject) => {
      let surveys = []
      localforageStoreSurveys.getItems().then((results) => {
        if (results) {
          for (let result in results) {
            const survey = JSON.parse(results[result])
            if (!survey.deleted) {
              surveys.push(survey)
            }
          }
        }
        commit('setSurveysToState', surveys)
        resolve(surveys)
      })
    })
  },
  loadAllSurveys ({ commit, state }) {
    return new Promise((resolve, reject) => {
      let surveys = []
      localforageStoreSurveys.getItems().then((results) => {
        if (results) {
          for (let result in results) {
            const survey = JSON.parse(results[result])
            surveys.push(survey)
          }
        }
        commit('setSurveysToState', surveys)
        resolve(surveys)
      })
    })
  },
  /**
   * unused for now
   */
  undeleteAllSurveys ({ commit }) {
    localforageStoreSurveys.getItems().then((results) => {
      if (results) {
        Object.keys(results).forEach(function (key, index) {
          let survey = JSON.parse(results[key])
          if (survey.deleted) {
            survey.deleted = false
            localforageStoreSurveys.setItem(key, JSON.stringify(survey))
          }
        })
      }
    })
  },
  undeleteSurvey ({ commit }, surveyId) {
    const key = 'survey-' + surveyId
    localforageStoreSurveys.getItem(key).then((result) => {
      let survey = JSON.parse(result)
      if (survey.deleted) {
        survey.deleted = false
        // TODO: we should proabbly send a commit with the survey
        localforageStoreSurveys.setItem(key, JSON.stringify(survey))
      }
    })
  },
  /**
   * triggers the mutation that sets the curent survey in the state
   */
  getSurveyById ({ commit }, surveyId) {
    return new Promise((resolve, reject) => {
      if (!surveyId) {
        reject('no survey id')
      }
      localforageStoreSurveys.getItem(String('survey-' + surveyId)).then((survey) => {
        commit('receiveSurvey', JSON.parse(survey))
        resolve()
      })
    })
  },
  addSurvey ({ commit }, survey) {
    return new Promise((resolve, reject) => {
      if (!survey || !survey.surveyId) {
        reject('no survey id')
      }
      // update local survey if already exists
      localforageStoreSurveys.getItem(String('survey-' + survey.surveyId)).then((result) => {
        let mergedSurvey = mergeApiDataToState(JSON.parse(result), survey)
        localforageStoreSurveys.setItem(String('survey-' + survey.surveyId), JSON.stringify(mergedSurvey)).then(() => {
          commit('addSurveyToState', mergedSurvey)
          resolve()
        })
      }).catch((error) => {
        console.log(error)
      })
    })
  },
  updateSurvey ({ commit }, survey) {
    return new Promise((resolve, reject) => {
      if (!survey.surveyId) {
        reject('no survey id')
      }
      localforageStoreSurveys.setItem(String('survey-' + survey.surveyId), JSON.stringify(survey)).then(() => {
        commit('receiveUpdatedSurvey', survey)
        resolve()
      })
    })
  },
  setSurveyAsOpened  ({ commit }, survey) {
    return new Promise((resolve, reject) => {
      if (!survey.surveyId) {
        reject('no survey id')
      }
      survey.opened = true
      localforageStoreSurveys.setItem(String('survey-' + survey.surveyId), JSON.stringify(survey)).then(() => {
        commit('updateSurveyInState', survey)
        resolve()
      })
    })
  },
  setSurveyAsSigned ({ commit }, { survey, signed }) {
    return new Promise((resolve, reject) => {
      if (!survey.surveyId) {
        reject('no survey id')
      }
      survey.signed = signed
      localforageStoreSurveys.setItem(String('survey-' + survey.surveyId), JSON.stringify(survey)).then(() => {
        commit('setSurveySignedInState', signed)
        commit('updateSurveyInState', survey)
        resolve()
      })
    })
  },
  setSurveyAsClosed ({ commit }, survey) {
    return new Promise((resolve, reject) => {
      if (!survey.surveyId) {
        reject('no survey id')
      }
      survey.closed = true
      localforageStoreSurveys.setItem(String('survey-' + survey.surveyId), JSON.stringify(survey)).then(() => {
        commit('setSurveyClosedInState', survey)
        commit('updateSurveyInState', survey)
        resolve()
      })
    })
  },
  setSurveyAsDeleted ({ commit }, surveyId) {
    return new Promise((resolve, reject) => {
      if (!surveyId) {
        reject('no survey id')
      }
      localforageStoreSurveys.getItem(String('survey-' + surveyId)).then((result) => {
        let survey = JSON.parse(result)
        if (survey) {
          survey.deleted = true
          localforageStoreSurveys.setItem(String('survey-' + survey.surveyId), JSON.stringify(survey)).then(() => {
            commit('setSurveyDeletedInState', survey)
            commit('updateSurveyInState', survey)
            resolve()
          })
        }
      })
    })
  },
  setSurveyAsUndeleted ({ commit }, surveyId) {
    return new Promise((resolve, reject) => {
      if (!surveyId) {
        reject('no survey id')
      }
      localforageStoreSurveys.getItem(String('survey-' + surveyId)).then((result) => {
        let survey = JSON.parse(result)
        if (survey) {
          survey.closed = true
          survey.deleted = false
          localforageStoreSurveys.setItem(String('survey-' + survey.surveyId), JSON.stringify(survey)).then(() => {
            commit('updateSurveyInState', survey)
            resolve()
          })
        }
      })
    })
  },
  permanentlyDeleteSurveyFromStorage ({ commit }, surveyId) {
    return new Promise((resolve, reject) => {
      if (!surveyId) {
        reject('no survey id')
      }
      // delete survey
      let key = String('survey-' + surveyId)
      localforageStoreSurveys.removeItem(key)
        .then(() => {
          commit('deleteSurveyInState', surveyId)
          resolve()
        })
    })
  },
  clearSurveysStorage ({ commit }) {
    return new Promise((resolve, reject) => {
      localforageStoreSurveys.clear().then(() => {
        commit('clearSurveysState')
        resolve()
      })
    })
  },
  importSurveys ({ commit }, surveys) {
    return new Promise((resolve, reject) => {
      commit('clearSurveysState')
      surveys.forEach((survey) => {
        if (!survey.surveyId) {
          reject('no survey id')
        }
        const key = 'survey-' + survey.surveyId
        localforageStoreSurveys.setItem(key, JSON.stringify(survey)).then(() => {
          commit('addSurveyToState', survey)
        })
      })
      resolve()
    })
  }
}

// mutations
const mutations = {
  receiveAllSurveys (state, surveys) {
    state.all = surveys
  },
  addSurveyToState (state, survey) {
    state.all.push(survey)
  },
  setSurveysToState (state, surveys) {
    state.all = surveys
  },
  updateSurveyInState (state, survey) {
    let surveyIndex = state.all.findIndex(element => element.surveyId === survey.surveyId)
    if (surveyIndex >= 0) {
      state.all[surveyIndex] = survey
    }
    // if touched state is the current survey, we also need to update the current survey in state
    if (state.survey && state.survey.surveyId === survey.surveyId) {
      state.survey = survey
    }
  },
  deleteSurveyInState (state, surveyId) {
    let surveyIndex = state.all.findIndex(element => element.surveyId === surveyId)
    if (surveyIndex >= 0) {
      state.all.splice(surveyIndex, 1)
    }
    // if touched state is the current survey, we also need to delete / reset the current survey in state
    if (state.survey && state.survey.surveyId === surveyId) {
      state.survey = null
    }
  },
  receiveSurvey (state, survey) {
    state.survey = survey
  },
  receiveUpdatedSurvey (state, survey) {
    let surveyIndex = state.all.findIndex(element => element.id === survey.surveyId)
    state.all[surveyIndex] = survey
    // if touched state is the current survey, we also need to update the current survey in state
    if (state.survey && state.survey.surveyId === survey.surveyId) {
      state.survey = survey
    }
  },
  /**
   * operations on single, current survey
   */
  setSurveySignedInState (state, signed) {
    state.survey.signed = signed
  },
  setSurveyClosedInState (state, survey) {
    state.survey = survey
  },
  setSurveyDeletedInState (state, survey) {
    state.survey = survey
  },
  clearSurveysState (state) {
    state = initialState
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/surveys.js